module.exports = __webpack_public_path__ + "img/Engagement_Under_Engaged_32@2x.57d12cbd.png";